module.exports = __webpack_public_path__ + "static/media/insta1.1515fda0.png";